<template>
  <el-dialog
    title="修改报名表单"
    :visible.sync="dialogVisible"
    width="900px"
    custom-class="mobile-form-dialog"
    :close-on-click-modal="false"
    top="5vh"
    @close="handleClose"
  >
    <el-form
      ref="formEditForm"
      :model="formEditData"
      :rules="formEditRules"
      label-width="180px"
      style="max-height: 70vh; overflow-y: auto; padding-right: 20px;"
    >
      <el-alert
        title="提示：items 和 feeItems 字段请使用 JSON 格式编辑"
        type="info"
        :closable="false"
        style="margin-bottom: 20px;"
      >
      </el-alert>

      <!-- 基本信息 -->
      <el-divider content-position="left">基本信息</el-divider>

      <el-form-item label="赛事名称" prop="eventName">
        <el-input v-model="formEditData.eventName" placeholder="请输入赛事名称">
          <copy-text slot="append" :value="formEditData.eventName" icon-only></copy-text>
        </el-input>
      </el-form-item>

      <el-form-item label="是否免费报名">
        <el-switch v-model="formEditData.isFree"></el-switch>
      </el-form-item>

      <el-form-item label="是否预报名">
        <el-switch v-model="formEditData.preRegister"></el-switch>
      </el-form-item>

      <el-form-item label="报名截止时间">
        <el-date-picker
          v-model="formEditData.deadline"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          default-time="23:59:00"
          placeholder="请选择报名截止时间"
          clearable
        ></el-date-picker>
      </el-form-item>

      <!-- 收集字段 -->
      <el-divider content-position="left">信息收集配置</el-divider>

      <el-form-item label="是否收集身份证号">
        <el-switch v-model="formEditData.collectIdNumber"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集收货地址">
        <el-switch v-model="formEditData.collectAddress"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集身高体重">
        <el-switch v-model="formEditData.collectHeightAndWeight"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集年龄">
        <el-switch v-model="formEditData.collectAge"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集生日">
        <el-switch v-model="formEditData.collectBirthday"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集邮箱">
        <el-switch v-model="formEditData.collectEmail"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集自媒体信息">
        <el-switch v-model="formEditData.collectWeMedia"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集学校信息">
        <el-switch v-model="formEditData.collectSchool"></el-switch>
      </el-form-item>

      <el-form-item label="是否收集学号">
        <el-switch v-model="formEditData.collectStudentNumber"></el-switch>
      </el-form-item>

      <el-form-item label="是否开启战队填写">
        <el-switch v-model="formEditData.enableTeam"></el-switch>
      </el-form-item>

      <!-- 报名项目 -->
      <el-divider content-position="left">报名项目配置</el-divider>

      <el-form-item label="报名项目 (JSON)" prop="itemsJson">
        <el-input
          type="textarea"
          v-model="formEditData.itemsJson"
          placeholder='请输入 JSON 格式，例如：[{"title":"男子传统健美","price":"100","groups":["A组","B组"]}]'
          :rows="8"
          @blur="validateItemsJson"
        ></el-input>
        <div style="margin-top: 5px; color: #909399; font-size: 12px;">
          格式：[{"title":"项目名","price":"价格","groups":["组别1","组别2"]}]
        </div>
      </el-form-item>

      <!-- 收费配置 -->
      <el-divider content-position="left">收费配置</el-divider>

      <el-form-item label="收费模式">
        <el-radio-group v-model="formEditData.feeType">
          <el-radio :label="1">主兼项收费</el-radio>
          <el-radio :label="2">按项目单独收费</el-radio>
        </el-radio-group>
      </el-form-item>

      <template v-if="formEditData.feeType === 1">
        <el-form-item label="主项费用">
          <el-input type="number" v-model="formEditData.mainFee" placeholder="请输入主项费用"></el-input>
        </el-form-item>
        <el-form-item label="兼项费用">
          <el-input type="number" v-model="formEditData.subFee" placeholder="请输入兼项费用"></el-input>
        </el-form-item>
        <el-form-item label="最大收费项目数">
          <el-input type="number" v-model.number="formEditData.maxItemLimit" placeholder="0表示不限制，超过后兼项不收费"></el-input>
          <div class="field-tip">仅主兼项收费模式生效；这是收费封顶数量，不限制运动员继续添加项目。</div>
        </el-form-item>
      </template>

      <el-form-item label="封顶费用">
        <el-input type="number" v-model="formEditData.maxFee" placeholder="请输入封顶费用"></el-input>
      </el-form-item>

      <el-form-item label="费用说明">
        <el-input
          type="textarea"
          v-model="formEditData.costExplanation"
          placeholder="请输入费用说明"
          :rows="3"
        ></el-input>
      </el-form-item>

      <el-form-item label="是否开启优惠码填写">
        <el-switch v-model="formEditData.enableCoupon"></el-switch>
      </el-form-item>

      <el-form-item v-if="formEditData.enableCoupon" label="优惠码说明文案">
        <el-input
          type="textarea"
          v-model="formEditData.couponDesc"
          placeholder="请输入如何获取优惠码的说明文案"
          :rows="3"
        ></el-input>
      </el-form-item>

      <!-- 油彩配置 -->
      <el-divider content-position="left">油彩配置</el-divider>

      <el-form-item label="是否强制预定油彩">
        <el-switch v-model="formEditData.enablePaint"></el-switch>
      </el-form-item>

      <el-form-item v-if="formEditData.enablePaint" label="油彩价格">
        <el-input type="number" v-model="formEditData.paintPrice" placeholder="请输入油彩价格"></el-input>
      </el-form-item>

      <!-- 课程配置 -->
      <el-divider content-position="left">课程配置</el-divider>

      <el-form-item label="是否开启课程收费">
        <el-switch v-model="formEditData.enableCourse"></el-switch>
      </el-form-item>

      <template v-if="formEditData.enableCourse">
        <el-form-item label="课程价格">
          <el-input type="number" v-model="formEditData.coursePrice" placeholder="请输入课程价格"></el-input>
        </el-form-item>
        <el-form-item label="课程描述">
          <el-input
            type="textarea"
            v-model="formEditData.courseDesc"
            placeholder="请输入课程描述"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="课程介绍链接">
          <el-input v-model="formEditData.courseUrl" placeholder="请输入课程介绍链接"></el-input>
        </el-form-item>
      </template>

      <!-- 其他收费项 -->
      <el-divider content-position="left">其他收费项</el-divider>

      <el-form-item label="其他收费项 (JSON)">
        <el-input
          type="textarea"
          v-model="formEditData.feeItemsJson"
          placeholder='请输入 JSON 格式，例如：[{"title":"T恤","price":"50","desc":"比赛T恤","img":"图片链接"}]'
          :rows="6"
        ></el-input>
        <div style="margin-top: 5px; color: #909399; font-size: 12px;">
          格式：[{"title":"标题","price":"价格","desc":"描述(可选)","img":"图片链接(可选)"}]
        </div>
      </el-form-item>

      <!-- 支付配置 -->
      <el-divider content-position="left">支付配置</el-divider>

      <el-form-item label="支付模式">
        <el-radio-group v-model="formEditData.paymentMode">
          <el-radio label="platform">平台代收</el-radio>
          <el-radio label="service_provider">服务商分账</el-radio>
        </el-radio-group>
      </el-form-item>

      <template v-if="formEditData.paymentMode === 'service_provider'">
        <el-form-item label="特约商户号">
          <el-input v-model="formEditData.subMchId" placeholder="请输入主办方的微信特约商户号"></el-input>
        </el-form-item>
        <el-form-item label="主办方名称">
          <el-input v-model="formEditData.organizerName" placeholder="请输入主办方名称"></el-input>
        </el-form-item>
      </template>

      <el-form-item label="服务费率(%)">
        <el-input-number
          v-model="formEditData.serviceFeeRate"
          :min="0"
          :max="100"
          :precision="2"
          :step="0.1"
        ></el-input-number>
        <span style="margin-left: 10px; color: #909399;">例如：12.5 表示抽成 12.5%</span>
      </el-form-item>

      <el-form-item label="固定服务费(元)">
        <el-input-number
          v-model="formEditData.serviceFeeFixed"
          :min="0"
          :precision="2"
        ></el-input-number>
        <span style="margin-left: 10px; color: #909399;">固定金额优先于费率</span>
      </el-form-item>

      <el-form-item label="手续费承担方">
        <el-radio-group v-model="formEditData.feeBearer">
          <el-radio label="platform">平台承担</el-radio>
          <el-radio label="organizer">主办方承担</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 联系方式 -->
      <el-divider content-position="left">联系方式</el-divider>

      <el-form-item label="联系方式类型">
        <el-select v-model="formEditData.registerType" placeholder="请选择">
          <el-option label="微信号" :value="0"></el-option>
          <el-option label="电话" :value="1"></el-option>
          <el-option label="微信二维码" :value="2"></el-option>
          <el-option label="微信群二维码" :value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="联系方式">
        <el-input v-model="formEditData.registerUrl" placeholder="请输入联系方式"></el-input>
      </el-form-item>

      <!-- 其他配置 -->
      <el-divider content-position="left">其他配置</el-divider>

      <el-form-item label="Webhook地址">
        <el-input v-model="formEditData.webhook" placeholder="请输入飞书群机器人Webhook地址"></el-input>
      </el-form-item>

      <el-form-item label="备注">
        <el-input
          type="textarea"
          v-model="formEditData.remarks"
          placeholder="请输入备注内容"
          :rows="3"
        ></el-input>
      </el-form-item>

      <el-form-item label="关联文案">
        <el-input v-model="formEditData.connectionDesc" placeholder="请输入关联文案"></el-input>
      </el-form-item>

      <el-form-item label="关联链接">
        <el-input v-model="formEditData.connectionUrl" placeholder="请输入关联链接"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定修改</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'FormDefineEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      formEditData: {
        id: '',
        eventName: '',
        deadline: '',
        isFree: false,
        preRegister: false,
        itemsJson: '',
        feeItemsJson: '',
        feeType: 1,
        mainFee: '',
        subFee: '',
        maxItemLimit: 0,
        maxFee: '',
        costExplanation: '',
        enableCoupon: false,
        couponDesc: '',
        webhook: '',
        remarks: '',
        // 收集字段
        collectIdNumber: false,
        collectAddress: false,
        collectHeightAndWeight: false,
        collectAge: true,
        collectBirthday: false,
        collectEmail: false,
        collectWeMedia: false,
        collectSchool: false,
        collectStudentNumber: false,
        // 战队
        enableTeam: false,
        // 油彩
        enablePaint: false,
        paintPrice: '',
        // 课程
        enableCourse: false,
        coursePrice: '',
        courseDesc: '',
        courseUrl: '',
        // 联系方式
        registerType: 0,
        registerUrl: '',
        // 关联
        connectionDesc: '',
        connectionUrl: '',
        // 支付配置
        paymentMode: 'platform',
        subMchId: '',
        organizerName: '',
        serviceFeeRate: 0,
        serviceFeeFixed: 0,
        feeBearer: 'organizer'
      },
      formEditRules: {
        eventName: [
          { required: true, message: '请输入赛事名称', trigger: 'blur' }
        ],
        itemsJson: [
          { required: true, message: '请输入报名项目JSON', trigger: 'blur' },
          { validator: this.validateItemsJsonFormat, trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.loadFormData();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    }
  },
  methods: {
    loadFormData() {
      if (!this.eventId) {
        this.$message.error('缺少赛事ID');
        return;
      }

      console.log('===== 开始加载表单数据 =====');
      console.log('赛事ID:', this.eventId);

      this.$axios
        .post('/form-define/find_by_id', JSON.stringify({ id: this.eventId }), {
          headers: {
            'x-auth-token': localStorage.getItem('bde_token'),
            'Content-Type': 'application/json'
          }
        })
        .then((res) => {
          console.log('接口响应:', res.data);

          if (res.data.code === 'success' && res.data.res) {
            // 注意：res.data.res 可能是数组，取第一个元素
            const formData = Array.isArray(res.data.res) ? res.data.res[0] : res.data.res;
            console.log('✅ 表单数据获取成功:', formData);

            if (!formData) {
              this.$message.error('未找到报名表单数据');
              return;
            }

            this.fillFormData(formData);
          } else {
            console.error('❌ 接口返回数据格式不正确');
            this.$message.error('未找到报名表单数据');
          }
        })
        .catch((err) => {
          console.error('❌ 接口调用失败:', err);
          this.$message.error(err.response?.data?.message || '获取报名表单数据失败');
          if (err.response?.data?.code === 'token_timeout') {
            this.$router.push('/login');
          }
        });
    },
    fillFormData(formData) {
      // 处理服务费率和固定服务费的显示转换
      let serviceFeeRate = formData.serviceFeeRate || 0;
      let serviceFeeFixed = formData.serviceFeeFixed || 0;

      // 将费率从小数转换为百分比（0.125 -> 12.5）
      if (serviceFeeRate && serviceFeeRate < 1) {
        serviceFeeRate = serviceFeeRate * 100;
      }

      // 将固定服务费从分转换为元（10000 -> 100）
      if (serviceFeeFixed) {
        serviceFeeFixed = serviceFeeFixed / 100;
      }

      // 填充表单数据
      this.formEditData = {
        id: formData._id,
        eventName: formData.eventName || '',
        deadline: formData.deadline || '',
        isFree: formData.isFree || false,
        preRegister: formData.preRegister || false,
        itemsJson: JSON.stringify(formData.items || [], null, 2),
        feeItemsJson: JSON.stringify(formData.feeItems || [], null, 2),
        feeType: formData.feeType || 1,
        mainFee: formData.mainFee || '',
        subFee: formData.subFee || '',
        maxItemLimit: formData.maxItemLimit || 0,
        maxFee: formData.maxFee || '',
        costExplanation: formData.costExplanation || '',
        enableCoupon: formData.enableCoupon || false,
        couponDesc: formData.couponDesc || '',
        webhook: formData.webhook || '',
        remarks: formData.remarks || '',
        // 收集字段
        collectIdNumber: formData.collectIdNumber || false,
        collectAddress: formData.collectAddress || false,
        collectHeightAndWeight: formData.collectHeightAndWeight || false,
        collectAge: formData.collectAge !== undefined ? formData.collectAge : true,
        collectBirthday: formData.collectBirthday || false,
        collectEmail: formData.collectEmail || false,
        collectWeMedia: formData.collectWeMedia || false,
        collectSchool: formData.collectSchool || false,
        collectStudentNumber: formData.collectStudentNumber || false,
        // 战队
        enableTeam: formData.enableTeam || false,
        // 油彩
        enablePaint: formData.enablePaint || false,
        paintPrice: formData.paintPrice || '',
        // 课程
        enableCourse: formData.enableCourse || false,
        coursePrice: formData.coursePrice || '',
        courseDesc: formData.courseDesc || '',
        courseUrl: formData.courseUrl || '',
        // 联系方式
        registerType: formData.register?.type !== undefined ? formData.register.type : 0,
        registerUrl: formData.register?.url || '',
        // 关联
        connectionDesc: formData.connectionDesc || '',
        connectionUrl: formData.connectionUrl || '',
        // 支付配置
        paymentMode: formData.paymentMode || 'platform',
        subMchId: formData.subMchId || '',
        organizerName: formData.organizerName || '',
        serviceFeeRate: serviceFeeRate,
        serviceFeeFixed: serviceFeeFixed,
        feeBearer: formData.feeBearer || 'organizer'
      };

      console.log('✅ 填充后的表单数据:', this.formEditData);

      // 清空表单验证
      this.$nextTick(() => {
        this.$refs.formEditForm && this.$refs.formEditForm.clearValidate();
      });
    },
    validateItemsJsonFormat(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入报名项目JSON'));
        return;
      }

      try {
        const items = JSON.parse(value);
        if (!Array.isArray(items)) {
          callback(new Error('items 必须是数组格式'));
          return;
        }

        // 验证数组中每个对象的格式
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (!item.title || !item.groups || !Array.isArray(item.groups)) {
            callback(new Error(`第 ${i + 1} 个项目格式不正确，必须包含 title 和 groups 字段`));
            return;
          }
        }

        callback();
      } catch (e) {
        callback(new Error('JSON 格式不正确：' + e.message));
      }
    },
    validateItemsJson() {
      this.$refs.formEditForm && this.$refs.formEditForm.validateField('itemsJson');
    },
    handleSubmit() {
      this.$refs.formEditForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请填写完整信息');
          return;
        }

        // 解析 items JSON
        let items;
        try {
          items = JSON.parse(this.formEditData.itemsJson);
        } catch (e) {
          this.$message.error('items JSON 格式不正确');
          return;
        }

        // 解析 feeItems JSON
        let feeItems = [];
        if (this.formEditData.feeItemsJson && this.formEditData.feeItemsJson.trim()) {
          try {
            feeItems = JSON.parse(this.formEditData.feeItemsJson);
          } catch (e) {
            this.$message.error('feeItems JSON 格式不正确');
            return;
          }
        }

        this.submitting = true;

        // 处理服务费率和固定服务费的提交转换
        let serviceFeeRate = this.formEditData.serviceFeeRate || 0;
        let serviceFeeFixed = this.formEditData.serviceFeeFixed || 0;

        // 将费率从百分比转换为小数（12.5 -> 0.125）
        if (serviceFeeRate) {
          serviceFeeRate = serviceFeeRate / 100;
        }

        // 将固定服务费从元转换为分（100 -> 10000）
        if (serviceFeeFixed) {
          serviceFeeFixed = Math.round(serviceFeeFixed * 100);
        }

        // 构建更新数据
        const updateData = {
          id: this.formEditData.id,
          eventName: this.formEditData.eventName,
          deadline: this.formEditData.deadline,
          isFree: this.formEditData.isFree,
          preRegister: this.formEditData.preRegister,
          items: items,
          feeItems: feeItems,
          feeType: this.formEditData.feeType,
          mainFee: this.formEditData.mainFee,
          subFee: this.formEditData.subFee,
          maxItemLimit: this.formEditData.maxItemLimit,
          maxFee: this.formEditData.maxFee,
          costExplanation: this.formEditData.costExplanation,
          enableCoupon: this.formEditData.enableCoupon,
          couponDesc: this.formEditData.couponDesc,
          webhook: this.formEditData.webhook,
          remarks: this.formEditData.remarks,
          // 收集字段
          collectIdNumber: this.formEditData.collectIdNumber,
          collectAddress: this.formEditData.collectAddress,
          collectHeightAndWeight: this.formEditData.collectHeightAndWeight,
          collectAge: this.formEditData.collectAge,
          collectBirthday: this.formEditData.collectBirthday,
          collectEmail: this.formEditData.collectEmail,
          collectWeMedia: this.formEditData.collectWeMedia,
          collectSchool: this.formEditData.collectSchool,
          collectStudentNumber: this.formEditData.collectStudentNumber,
          // 战队
          enableTeam: this.formEditData.enableTeam,
          // 油彩
          enablePaint: this.formEditData.enablePaint,
          paintPrice: this.formEditData.paintPrice,
          // 课程
          enableCourse: this.formEditData.enableCourse,
          coursePrice: this.formEditData.coursePrice,
          courseDesc: this.formEditData.courseDesc,
          courseUrl: this.formEditData.courseUrl,
          // 联系方式
          register: {
            type: this.formEditData.registerType,
            url: this.formEditData.registerUrl
          },
          // 关联
          connectionDesc: this.formEditData.connectionDesc,
          connectionUrl: this.formEditData.connectionUrl,
          // 支付配置
          paymentMode: this.formEditData.paymentMode,
          subMchId: this.formEditData.subMchId,
          organizerName: this.formEditData.organizerName,
          serviceFeeRate: serviceFeeRate,
          serviceFeeFixed: serviceFeeFixed,
          feeBearer: this.formEditData.feeBearer
        };

        console.log('提交的更新数据:', updateData);

        // 调用更新接口
        this.$axios
          .post('/form-define/update', JSON.stringify(updateData), {
            headers: {
              'x-auth-token': localStorage.getItem('bde_token'),
              'Content-Type': 'application/json'
            }
          })
          .then((res) => {
            if (res.data.code === 'success') {
              this.$message.success('修改成功');
              this.handleClose();
              this.$emit('success');
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.response?.data?.message || '修改失败');
            if (err.response?.data?.code === 'token_timeout') {
              this.$router.push('/login');
            }
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.field-tip {
  margin-top: 5px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
